import { Outlet } from "react-router-dom";

import Directory from "../../components/directory/directory.component";
import Slider from "../../components/slider-home/slider.component";
import AnimationPage from "../../components/smallcomponents/animation.component";
import Newsletter from "../../components/smallcomponents/newsletter.component";

const Home = () => {
  return (
    <AnimationPage>
      <Slider />
      <Directory />
      <Newsletter />
      <Outlet />
    </AnimationPage>
  );
};

export default Home;
